<template>
    <div>
        <b-modal
            :id="modalId"
            modal-class="modal-confirm-redeem"
            centered
            hide-header
            hide-footer
            no-close-on-backdrop
            no-close-on-esc>
            <div class="modal-base"
                :class="[{'mass': theme == 'mass'}, {'prestige': theme == 'prestige'}]">
                <div class="modal-base-body">
                    <p id="ambassador_message" class="message" v-html="lblConfirm.message"></p>
                </div>
                <div class="modal-base-footer">
                    <div id="ambassador_confirm_btn_row" class="confirm-modal-btn-row">
                        <div class="confirm-modal-btn">
                            <SecondaryButton
                                btnId="confirm_redeem_cancel_btn"
                                :btnMsg="lblConfirm.btnSecondary"
                                @clickButton="clickCancel()" />
                        </div>
                        <div class="confirm-modal-btn">
                            <PrimaryButton
                                btnId="confirm_redeem_confirm_btn"
                                :btnMsg="lblConfirm.btnPrimary"
                                @clickButton="clickConfirm()" />
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
    </div>
</template>
<script>
export default {
    name: 'AmbassadorConfirm',
    computed: {
        theme: function () {
            return this.$store.state.theme;
        }
    },
    props: {
        lblConfirm: Object,
        modalId: String
    },
    methods: {
        //event
        clickConfirm: function () {
            this.$emit('clickConfirm', {tag: 'ambassador-confirm'});
        },
        clickCancel: function () {
            this.$emit('clickCancel', {tag: 'ambassador-confirm'});
        },
        //modal
        show: function () {
            this.$bvModal.show(this.modalId);
        },
        hide: function () {
            this.$bvModal.hide(this.modalId);
        }
    }
}
</script>
